import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { Options } from 'ng5-slider';
import { SilderSetting, CTSilderSetting } from '../../../service/recordview-param';

@Component({
	selector: 'common-slider-setting',
	templateUrl: './slider-setting.component.html',
	styleUrls: ['./slider-setting.component.scss']
})
export class SliderSettingComponent implements OnInit {
	@HostBinding('class.slider-setting') hostClass = true;
	upValue = 1;
	downValue = 50;
	@Input() set inData(val: CTSilderSetting) {
		this.data = new SilderSetting(val);
		this.options = this.data.toOptions();
	}
	data: SilderSetting;

	options: Options = SilderSetting.defaultOptions();

	constructor() {}

	ngOnInit() {}
}
